import type { ValuationOverview as ValuationOverviewSchema } from '@einwert/valuation-api-client'

import { isoDateStringToLocalFormat, ListCardInfo, tokens } from 'ComponentLibrary'
import { Stack } from '@mui/material'
import Typography from 'ComponentLibrary/src/piazza/text/Typography/Typography'
import { useTranslation } from 'react-i18next'
import { useCurrentResolvedLocale } from 'ClientPortal/src/i18n/currentLocale'

export const OrderInfoCell = ({ valuation }: { valuation: ValuationOverviewSchema }) => {
    const { t: tCommon } = useTranslation('terminology', { keyPrefix: 'common' })
    const locale = useCurrentResolvedLocale()
    const valuationDate = isoDateStringToLocalFormat(valuation.latest_valuation_date, false, locale)
    const orderDate = isoDateStringToLocalFormat(valuation.order_date, false, locale)
    const orderStatus = valuation.order_status
    const showOrderDate = orderDate && orderStatus !== 'temp_hide_in_portal'
    return (
        <ListCardInfo
            style={{
                minWidth: '290px',
                height: '50px',
                flexGrow: 1,
                padding: tokens.SizingSpacing075,
                borderRadius: tokens.SizingCornerS,
                backgroundColor: tokens.ColorSurfaceInverseDefault,
                gap: tokens.SizingSpacing025,
            }}
        >
            <Stack direction="row" width="100%" justifyContent="space-between" gap={tokens.SizingSpacing075}>
                <Typography variant="textS" color={tokens.ColorTextSubtle}>
                    {tCommon('orderDate')}
                </Typography>
                <Typography variant="textS" color={showOrderDate ? tokens.ColorTextBold : tokens.ColorTextDisabled}>
                    {showOrderDate ? orderDate : tCommon('noDate')}
                </Typography>
            </Stack>
            <Stack direction="row" width="100%" justifyContent="space-between" gap={tokens.SizingSpacing075}>
                <Typography variant="textS" color={tokens.ColorTextSubtle}>
                    {tCommon('valuationDate')}
                </Typography>
                <Typography variant="textS" color={valuationDate ? tokens.ColorTextBold : tokens.ColorTextDisabled}>
                    {valuationDate || tCommon('noDate')}
                </Typography>
            </Stack>
        </ListCardInfo>
    )
}
